// services/health.service.js
//
// Chequea la salud de los servicios de la plataforma para el panel "System
// status" de Soporte. Los endpoints /health son públicos (sin auth) y
// responden con CORS `*`, así que se consultan directo desde el browser.
//
// Un servicio se considera UP si responde HTTP 200 y su campo `status`
// matchea /healthy|ok|up|running/ (tolera el prefijo emoji 🟢). Cualquier
// no-200, timeout o error de red => DOWN.

const SERVICES = [
  { key: "assistant", label: "Assistant", url: process.env.REACT_APP_ASSISTANT_API_URL },
  { key: "workflows", label: "Workflow service", url: process.env.REACT_APP_WORKFLOW_API_URL },
  { key: "runner", label: "Workflow runner", url: process.env.REACT_APP_EXECUTION_API_URL },
  { key: "rag", label: "Knowledge (RAG)", url: process.env.REACT_APP_RAG_API_URL },
  { key: "images", label: "Images", url: process.env.REACT_APP_IMAGES_API_URL },
  { key: "connections", label: "Connections", url: process.env.REACT_APP_CONNECTIONS_API_URL },
];

const TIMEOUT_MS = 6000;
const HEALTHY_RE = /healthy|ok|up|running/;

async function checkOne(svc) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const base = svc.url.replace(/\/+$/, "");
    const res = await fetch(`${base}/health`, { method: "GET", signal: controller.signal });
    clearTimeout(timer);
    if (!res.ok) return { key: svc.key, label: svc.label, up: false };

    let up = true;
    try {
      const data = await res.json();
      const status = String(data.status || "").toLowerCase();
      up = status === "" || HEALTHY_RE.test(status);
    } catch (e) {
      up = true; // 200 sin JSON parseable: lo tomamos como up
    }
    return { key: svc.key, label: svc.label, up };
  } catch (e) {
    clearTimeout(timer);
    return { key: svc.key, label: svc.label, up: false };
  }
}

class HealthService {
  /**
   * Consulta todos los servicios configurados en paralelo.
   * @returns {Promise<{services: Array, allUp: boolean, anyDown: boolean, down: Array, botUp: boolean}>}
   */
  async check() {
    const targets = SERVICES.filter((s) => s.url);
    const services = await Promise.all(targets.map(checkOne));
    const down = services.filter((s) => !s.up);
    const bot = services.find((s) => s.key === "assistant");
    return {
      services,
      down,
      allUp: services.length > 0 && down.length === 0,
      anyDown: down.length > 0,
      botUp: bot ? bot.up : false,
    };
  }
}

export default new HealthService();
